import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { usePagination } from '@webapp/core/hooks/usePagination/usePagination'
import { type PaginationID } from '@webapp/core/providers/Pagination/pagination.types'

export interface IResetPaginationProps {
  id: PaginationID
}

export const ResetPagination = ({
  id,
  children,
}: PropsWithChildren<IResetPaginationProps>) => {
  const { reset } = usePagination({ id })

  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    reset()
    setIsReady(true)
  }, [])

  return isReady ? <>{children}</> : null
}
